"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolbarComboboxFilter = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@veeam/core");
const public_1 = require("../../common/public");
const Combobox_1 = require("../../controls/Combobox");
const StackView_1 = require("../../StackView");
const Suggest_1 = require("../../Suggest");
const Toolbar_1 = require("../../Toolbar");
function toolbarComboboxFilter({ title, property, groupId = '', operation = core_1.FILTER_OPERATION.in, collation = core_1.FILTER_COLLATION.ignorecase, disabled, decorators, allValue = null, fieldConfig = {}, dropdownWidth, items }) {
    return {
        decorators,
        disabled,
        hasStretch: fieldConfig.size === public_1.CONTROL_SIZE.full,
        render: (model, { disabled }) => {
            return (react_1.default.createElement(core_1.ModelRenderer, { model: model, render: ({ value }) => {
                    let currentValue = value.filters.getFilterValue({ property, groupId }) || allValue;
                    if (Array.isArray(currentValue)) {
                        currentValue = currentValue[0];
                    }
                    return (react_1.default.createElement(StackView_1.StackView, { align: StackView_1.STACK_ALIGN.center, direction: StackView_1.STACK_DIRECTION.row },
                        !!title && react_1.default.createElement(Toolbar_1.ToolbarText, { text: title }),
                        react_1.default.createElement(Combobox_1.Combobox, { value: currentValue, valueGetter: (data) => data.value, textGetter: (data) => data.title, size: fieldConfig.size, texts: fieldConfig.texts, disabled: disabled, dropdownWidth: dropdownWidth, optionRenderer: (0, Suggest_1.createDefaultOption)({
                                iconGetter: ({ option }) => option.icon || ''
                            }), data: items, onChange: (nextValue) => {
                                if (nextValue === allValue) {
                                    model.setFilter({ property, groupId }, {
                                        operation,
                                        collation,
                                        value: nextValue === allValue ? allValue : null
                                    });
                                    return;
                                }
                                model.setFilter({ property, groupId }, {
                                    operation,
                                    collation,
                                    value: operation === core_1.FILTER_OPERATION.in
                                        ? [nextValue]
                                        : nextValue
                                });
                            } })));
                } }));
        }
    };
}
exports.toolbarComboboxFilter = toolbarComboboxFilter;
//# sourceMappingURL=toolbarComboboxFilter.js.map